<template>
  <div class="w-3/5 pt-6">
    <div class="text-2xl font-light italic py-12 pl-6 border-l-8 border-gray-300 dark:border-gray-700">
      <slot/>
    </div>
  </div>
</template>
